import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import Predicate from "../components/Predicate";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import defaultPredicateOption from "../components/Predicate/const/defaultPredicateOption";
import ContentWithTopLabel from "../components/ContentWithTopLabel";
import SelectBoxWithInput from "../components/SelectBoxWithInput";
import PanelLayout from "../components/PanelLayout";


class PushPanel extends Component {

    constructor(props){
        super(props);
        this.pushTypeOptions = [
            {
                label:"Add To Prediction",
                value:"addToPrediction"
            },
            {
                label:"Multiply Prediction",
                value:"multiplyPrediction"
            },
            {
                label:"Zero or Constant Value",
                value:"linearPushToZeroOrOne"
            }
        ];

        this.hasOptions = this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.simplePush;
        this.hasPredicate = this.hasOptions && this.props.clickedNodeInfo.extras.options.simplePush.predicate;
        this.hasPushMode = this.hasOptions && this.props.clickedNodeInfo.extras.options.simplePush.pushMode;

        this.state = {
            selectedTab: "NodeDetail",
            predicate: this.hasPredicate ? this.props.clickedNodeInfo.extras.options.simplePush.predicate : {
                type: "and",
                predicates: [
                    defaultPredicateOption
                ]
            },
            pushMode: this.hasPushMode ? this.props.clickedNodeInfo.extras.options.simplePush.pushMode : {
                pushParam:"0.1",
                pushType:this.pushTypeOptions[0].value
            },


        };
        this.changeTab = this.changeTab.bind(this);
        this.onPushParamChange = this.onPushParamChange.bind(this);
        this.onPushTypeChange = this.onPushTypeChange.bind(this);
    }

    changeTab(event) {
        this.setState({selectedTab: event.currentTarget.dataset.id});
    }


    onOptionsUpdate(type, value) {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let simplePushInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(simplePushInfo.extras, "options")) {
            simplePushInfo.extras.options = {};
        }
        simplePushInfo.extras.options = {
            ...simplePushInfo.extras.options,
            simplePush: {
                ...simplePushInfo.extras.options.simplePush,
                [type]: value
            }
        };

        this.props.clickedNodeAction(simplePushInfo);
    }

    onPropertyUpdate(propertyName, index, value) {
        let propertyUpdate = this.state[propertyName];
        propertyUpdate[index] = value;
        this.setState({
            [propertyName]: propertyUpdate
        }, () => this.onOptionsUpdate(propertyName, this.state[propertyName]));
    }

    onPushParamChange(value){
        this.setState({pushParam: value}
            , () => this.onPropertyUpdate("pushMode","pushParam", this.state.pushParam));
    }

    onPushTypeChange(value){
        this.setState({pushType: value},
            () => this.onPropertyUpdate("pushMode", "pushType", this.state.pushType)
        );
    }

    render(){
        return (
            <PanelLayout>
                <SelectBoxWithInput label="Push Type"
                                    selectValue={this.state.pushMode.pushType}
                                    selectArray={this.pushTypeOptions.map(function (object){
                                        return {label: object.label, value: object.value}
                                    })}
                                    handleChangeSelect={(event) => this.onPushTypeChange(event.target.value)}
                                    handleChangeInput={(e) => this.onPushParamChange(e.target.value)}
                                    numberInput={this.state.pushMode.pushParam}

                />

                <ContentWithTopLabel label="Item Filter">
                    <Predicate updateOptions={(predicate) => this.onOptionsUpdate("predicate", predicate)} predicate={this.state.predicate}/>
                </ContentWithTopLabel>
            </PanelLayout>
        );
    }

}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
        node: state.modalInfo.node
    }
}

export default connect(mapStateToProps, {
    hideModal,
    clickedNodeAction,

})(PushPanel);


